// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmModal {
  pointer-events: none;
  overflow: unset !important;
}
.confirmModal .ant-modal-close-x {
  display: none;
}
.confirmModal .ant-modal-content {
  border-radius: 8px;
}
.confirmModal .ant-modal-header {
  padding: 0;
  cursor: move;
  background-color: #F3F4F5;
  border-color: lightgray;
}
.confirmModal .ant-modal-header .ant-modal-title {
  font-weight: 500;
  color: black;
  font-size: 18px;
}
.confirmModal .ant-modal-header .ant-modal-title div {
  padding: 20px 24px 6px 24px;
}
.confirmModal .ant-modal-body {
  background-color: #F3F4F5;
  padding: 0;
}
.confirmModal .ant-modal-body .contentWrapper {
  display: flex;
  align-items: center;
  height: 50px;
}
.confirmModal .ant-modal-body .contentWrapper .hintMessage {
  padding: 0 24px;
  font-size: 14px;
  font-weight: 500;
}
.confirmModal .ant-modal-body .buttonGroup {
  padding: 12px 24px;
}
.confirmModal .ant-modal-body .buttonGroup::after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}
.confirmModal .ant-modal-body .buttonGroup div {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  background-color: white;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.confirmModal .ant-modal-body .buttonGroup div:nth-of-type(1) {
  float: left;
  width: 102px;
}
.confirmModal .ant-modal-body .buttonGroup div:nth-of-type(2) {
  width: 102px;
  float: right;
}
`, "",{"version":3,"sources":["webpack://./src/Components/HintModal/index.less"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,0BAAA;AACF;AAHA;EAKI,aAAA;AACJ;AANA;EASI,kBAAA;AAAJ;AATA;EAcI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;AAFJ;AAfA;EAoBM,gBAAA;EACA,YAAA;EACA,eAAA;AAFN;AApBA;EAwBQ,2BAAA;AADR;AAvBA;EA8BI,yBAAA;EACA,UAAA;AAJJ;AA3BA;EAkCM,aAAA;EACA,mBAAA;EACA,YAAA;AAJN;AAhCA;EAuCQ,eAAA;EACA,eAAA;EACA,gBAAA;AAJR;AArCA;EAgDM,kBAAA;AARN;AASM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AAPR;AA9CA;EAyDQ,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AARR;AAUQ;EACE,WAAA;EACA,YAAA;AARV;AAWQ;EACE,YAAA;EACA,YAAA;AATV","sourcesContent":[".confirmModal {\n  pointer-events: none;\n  overflow: unset !important;\n\n  .ant-modal-close-x {\n    display: none;\n  }\n\n  .ant-modal-content {\n    border-radius: 8px;\n  }\n\n\n  .ant-modal-header {\n    padding: 0;\n    cursor: move;\n    background-color: #F3F4F5;\n    border-color: lightgray;\n\n    .ant-modal-title {\n      font-weight: 500;\n      color: black;\n      font-size: 18px;\n      div {\n        padding: 20px 24px 6px 24px;\n      }\n    }\n  }\n\n  .ant-modal-body {\n    background-color: #F3F4F5;\n    padding: 0;\n\n    .contentWrapper {\n      display: flex;\n      align-items: center;\n      height: 50px;\n\n      .hintMessage {\n        padding: 0 24px;\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n\n\n    .buttonGroup {\n      //border-top: 1px solid lightgray;\n      padding: 12px 24px;\n      &::after {\n        content: '';\n        display: block;\n        visibility: hidden;\n        clear: both;\n      }\n\n      div {\n        display: inline-block;\n        height: 32px;\n        line-height: 32px;\n        border-radius: 8px;\n        background-color: white;\n        text-align: center;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n\n        &:nth-of-type(1) {\n          float: left;\n          width: 102px;\n        }\n\n        &:nth-of-type(2) {\n          width: 102px;\n          float: right;\n        }\n      }\n    }\n  }\n}\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
